module Meevo.Plugins.ChartPhrases {
    "use strict";

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ChartPhrases> {
        private static hooksRegistered = false;
        private static activeSection: MainSection = null;

        chartPhraseElement: any;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected webComponentMountHooks?: any,
            protected $scope?: angular.IScope,
            private context?: Meevo.Components.BaseClasses.IDataMaintenanceContext,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            MainSection.activeSection = this;
            this.registerWebComponentHooks();
            this.setWatchers();
        }

        sectionModelRetrieved() {
            super.sectionModelRetrieved();
            this.pushInputsToWebComponent();
        }

        private registerWebComponentHooks(): void {
            if (!this.webComponentMountHooks || MainSection.hooksRegistered) {
                return;
            }

            this.webComponentMountHooks.register('chart-phrases', (element: HTMLElement) => {
                var section = MainSection.activeSection;
                if (!section) {
                    return;
                }

                section.chartPhraseElement = element;
                section.pushInputsToWebComponent();
                element.addEventListener('formDataChange', section.onFormDataChange.bind(section));
            });

            MainSection.hooksRegistered = true;
        }

        private pushInputsToWebComponent(): void {
            if (!this.chartPhraseElement) {
                return;
            }

            this.chartPhraseElement.formData = this.model;
            this.chartPhraseElement.isReadonly = !!(this.context && this.context.isReadonly);
        }

        private onFormDataChange(event: CustomEvent): void {
            const { detail } = event;

            this.model = detail;

            /*if (this.$scope) {
                this.$scope.$evalAsync();
            }*/
        }

        private setWatchers(): void {
            this.$scope.$watch(() => this.context.isReadonly, (newValue, oldValue) => {
                    this.chartPhraseElement ? this.chartPhraseElement.isReadonly = newValue : null;
                }, true);    
        }
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate("chartPhrase").then((data) => {
                this.model = data;
                this.model.locationOverride = { locations: [] };
                this.pushInputsToWebComponent();
            });
        }

        postCopy() {
            this.model.id = '';
            this.model.displayName = '';
            this.model.shortcut = '';

            this.chartPhraseElement.formData = { ...this.model };
        }

        preSave() {
            super.preSave();

            if (this.model.allCharts) {
                this.model.chartDefinitions = [];
            }

            if (this.model.chartDefinitions.length) {
                this.model.allCharts = false;
            }
            if (this.model.takeOwnership) {
                (this.context as any).takeOwnership = true;
            }
        }
    }
}
